import { render, staticRenderFns } from "./MDetailLock.vue?vue&type=template&id=81413e76&scoped=true"
import script from "./MDetailLock.vue?vue&type=script&lang=js"
export * from "./MDetailLock.vue?vue&type=script&lang=js"
import style0 from "./MDetailLock.vue?vue&type=style&index=0&id=81413e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81413e76",
  null
  
)

export default component.exports